import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=281fc9f4&scoped=true&"
import script from "./CompanyDetail.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=281fc9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281fc9f4",
  null
  
)

export default component.exports